import type { FC } from 'react';
import { useContext } from 'react';
import { InstantSearch } from 'react-instantsearch-core';

import { Configure } from '@/components/Configure';
import { useAlgoliaUserToken } from '@/hooks/useAlgoliaUserToken';
import { getIndexName } from '@/integrations/algolia/helpers';
import { createSearchClient } from '@/integrations/algolia/searchClientBuilder';
import type { WithChildren } from '@/lib/types';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';
import { LocaleContext } from '@/providers/LocaleProvider';

interface StoresSearchProp extends WithChildren {
  storeId?: string;
}

export const StoresSearch: FC<StoresSearchProp> = ({ children, storeId }) => {
  const locale = useContext(LocaleContext);
  const draftMode = useContext(DraftModeContext);
  const { userToken } = useAlgoliaUserToken();
  const algoliaSearchClient = createSearchClient({
    isPreview: draftMode,
  });
  if (!storeId) {
    return <></>;
  }
  return (
    <InstantSearch
      indexName={getIndexName('STORE', locale)}
      insights={{ insightsInitParams: { userToken } as any }}
      searchClient={algoliaSearchClient}
    >
      <Configure facetFilters={[`store_id:${storeId}`]} />
      {children}
    </InstantSearch>
  );
};

export default StoresSearch;
